// {
//   "name": "iconic-advance-faq.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
    class CategoryAccordion {
      constructor(container) {
        this.container = container;
        this.initialize();
      }
  
      initialize() {
        // Set up the event listeners and initial state
        this.setupEventListeners();
        this.initializeCategories();
      }
  
      setupEventListeners() {
        const categoryButtons = this.container.querySelectorAll(
          "[class*='iconic-category-']"
        );
  
        categoryButtons.forEach((btn) => {
          btn.addEventListener("click", (event) => {
            const btn = event.target;
            const parent = btn.closest("div");
            const headCategory = parent.closest(".head_category");
            const eventId = parent.getAttribute("id");
            const allSiblings = Array.from(parent.parentElement.children);
  
            allSiblings.forEach((sibling) => {
              sibling.classList.remove("active");
              const eventIdsibling = sibling.getAttribute("id");
              this.container
                .querySelectorAll(`.${eventIdsibling}`)
                .forEach((siblingfaq) => {
                  siblingfaq.classList.add("iconic-d-none");
                });
            });
  
            parent.classList.add("active");
  
            this.container.querySelectorAll(`.${eventId}`).forEach((faq) => {
              faq.classList.remove("iconic-d-none");
              const accordionType = headCategory.getAttribute("data-accordion");
              if (accordionType === "first_open") {
                faq.classList.remove("open");
              }
            });
  
            const children = this.container.querySelectorAll(`.${eventId}`);
            if (children.length > 0) {
              const accordionType = headCategory.getAttribute("data-accordion");
              if (accordionType === "first_open") {
                children[0].classList.add("open");
              } else if (accordionType === "all_close") {
                children[0].classList.remove("open");
              }
            }
          });
        });
      }
  
      initializeCategories() {
        const headCategories = this.container.querySelectorAll(".head_category");
  
        headCategories.forEach((child) => {
          let activeCat = child.firstElementChild;
          activeCat.classList.add("active");
          let activeId = activeCat.getAttribute("id");
          const children = this.container.querySelectorAll(`.${activeId}`);
  
          if (children.length > 0) {
            const accordionType = child.getAttribute("data-accordion");
            if (accordionType === "first_open") {
              children[0].classList.add("open");
            } else if (accordionType === "all_close") {
              children[0].classList.remove("open");
            }
          }
  
          this.container
            .querySelectorAll(`.${activeId}`)
            .forEach((siblingfaq) => {
              siblingfaq.classList.remove("iconic-d-none");
            });
        });
      }
    }
    function initializeAccordions() {
      document.querySelectorAll("iconic-advance-accordion").forEach((container) => {
        new CategoryAccordion(container);
      });
    }
  
    document.addEventListener("DOMContentLoaded", initializeAccordions);
     if (Shopify.designMode) {
        initializeAccordions();
     }
    document.addEventListener("shopify:section:load", initializeAccordions);
    document.addEventListener("shopify:section:select", initializeAccordions);
  })();